/* eslint-disable security/detect-object-injection */
import * as React from 'react';
import { Form } from 'react-bootstrap';

import { FormContext } from '@/helper/context';
import { camelToTitle } from '@/helper/utility';

interface Properties {
  name: string;
  displayName?: string;
  size?: string;
  value?: string;
  valueSelect?: string;
  rows?: number;
  children?: React.ReactNode;
}

export function InputTextArea({ name, displayName, size, value, valueSelect, rows = 6, children }: Properties) {
  if (!displayName) displayName = camelToTitle(name);
  const [valueState, setValueState] = React.useState((valueSelect ?? value) || '');
  const { changeTracker, setWasChanged, disabled, errors } = React.useContext(FormContext);
  const setSize = size || 'col-12';

  React.useEffect(() => {
    const didChange = valueSelect ? (valueSelect == value ? false : true) : false;
    changeTracker.current = {
      ...changeTracker.current,
      [name]: didChange
    };
    setWasChanged(Object.values(changeTracker.current).includes(true));
  }, []);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    setValueState(event.target.value);

    const didChange = event.target.value == value ? false : true;
    changeTracker.current = {
      ...changeTracker.current,
      [name]: didChange
    };
    setWasChanged(Object.values(changeTracker.current).includes(true));
  }

  return (
    <Form.Group controlId={name} className={`mt-3 ${setSize}`}>
      <Form.Label>{children ?? displayName}</Form.Label>
      <Form.Control
        as='textarea'
        rows={rows}
        disabled={disabled}
        type='text'
        name={name}
        value={valueState}
        onChange={onChange}
        isInvalid={errors[name] ? true : false}
      />
      <Form.Control.Feedback type='invalid'>{errors[name]}</Form.Control.Feedback>
    </Form.Group>
  );
}
